import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-b69e9d60")
const _hoisted_1 = { class: "p-mb-2" }
const _hoisted_2 = { class: "p-m-0" }
const _hoisted_3 = {
  key: 0,
  class: "p-m-0"
}
const _hoisted_4 = { style: {"display":"flex","flex-flow":"row nowrap","justify-content":"space-between"} }
const _hoisted_5 = { class: "data" }
const _hoisted_6 = { class: "p-grid" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", { class: "p-col-4" }, "Cliente: ", -1)
const _hoisted_8 = { class: "p-col-8" }
const _hoisted_9 = { class: "p-grid" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", { class: "p-col-4" }, "Mezzo: ", -1)
const _hoisted_11 = { class: "p-col-8" }
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "actions" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderPriorityTimes = _resolveComponent("OrderPriorityTimes")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("strong", _hoisted_2, "Ordine #" + _toDisplayString(_ctx.order.id), 1),
      (_ctx.order.external_client_code)
        ? (_openBlock(), _createElementBlock("strong", _hoisted_3, "  - " + _toDisplayString(_ctx.order.external_client_code), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_OrderPriorityTimes, {
        data: _ctx.order,
        class: "p-ml-auto"
      }, null, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("i", _hoisted_8, _toDisplayString(_ctx.order.customer.name) + " " + _toDisplayString(_ctx.order.customer.surname), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, [
            _createElementVNode("i", {
              class: _normalizeClass(`fas fa-${_ctx.order.vehicle?.icon}`),
              title: _ctx.order.vehicle.name_it
            }, null, 10, _hoisted_12),
            _createTextVNode(" " + _toDisplayString(_ctx.order.vehicle.name_it), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ])
  ]))
}